import Runtime from './Runtime'
import userHasScope from './userHasScope'
import bootstrapRuntime from './bootstrapRuntime'

Runtime.userHasScope = userHasScope
Runtime.bootstrapRuntime = bootstrapRuntime

export default Runtime
